import * as React from "react"
import { withTranslation } from "react-i18next"
import { Field } from "@atlaskit/form"
import { IBaseProps } from "../../../../utils/BaseProps"
import FieldValue from "../partials/FieldValue"
import { MetaData_oenorms as OenormType } from "../../../../api/graphql/queries/types/MetaData"
import { transformOptionLabel } from "../fields/EditSelect"
import { toSelectOption as oenormsToSelectOption } from "../../../../api/graphql/fragments/Oenorm";

interface IShowOenormProps extends IBaseProps {
  name: String
  translation: String
  oenorm?: OenormType | null
}

export default withTranslation()((props: IShowOenormProps) => (
  <Field name={props.name} label={props.t(`${props.translation}.title`)} helperText={props.t(`${props.translation}.helper`)}>
    {() => {
      const option = props.oenorm ? oenormsToSelectOption([props.oenorm]).shift() : undefined
      return (
        <FieldValue>
          {option ? transformOptionLabel(option) : "-"}
        </FieldValue>
      )
    }}
  </Field>
))